import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Alert, Box, Button, Card, CardContent, Typography } from '@mui/material';
import { tariffsApi } from '../services/api';
import { useShell } from './Layout';
import { apiError, pluralize } from '../utils/format';
import { tokens } from '../theme';

// «Бесплатный доступ на N дня» on the tariffs page: the free trial is taken with this button, not
// on sign-up. Shown only to an account that may take it; an agent is told why it cannot.
const TrialCard = () => {
  const { reloadShell } = useShell();
  const navigate = useNavigate();
  const [info, setInfo] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    tariffsApi.trial().then((r) => setInfo(r.data)).catch(() => {});
  }, []);

  if (!info) return null;
  if (!info.available) {
    return info.reason === 'agent' ? (
      <Alert severity="info" sx={{ mb: 2 }}>
        Бесплатный доступ не предоставляется участникам партнёрской программы: выберите тариф ниже, и сервис откроется после оплаты.
      </Alert>
    ) : null;
  }

  const take = async () => {
    setBusy(true);
    setError('');
    try {
      await tariffsApi.claimTrial();
      await reloadShell();
      navigate('/dashboard');
    } catch (err) {
      setError(apiError(err));
      setBusy(false);
    }
  };

  const days = `${info.days} ${pluralize(info.days, 'день', 'дня', 'дней')}`;
  return (
    <Card sx={{ mb: 3, background: tokens.heroGradient }}>
      <CardContent sx={{ display: 'flex', alignItems: 'center', gap: 2.5, flexWrap: 'wrap' }}>
        <Box sx={{ flex: 1, minWidth: 260 }}>
          <Typography variant="h3" sx={{ mb: 0.5 }}>Бесплатный доступ на {days}</Typography>
          <Typography color="text.secondary">
            Попробуйте сервис без оплаты: все разделы открыты, кроме скачивания отчётов. Выбрать тариф можно в любой момент.
          </Typography>
          {error && <Alert severity="error" sx={{ mt: 1.5 }}>{error}</Alert>}
        </Box>
        <Button variant="contained" size="large" onClick={take} disabled={busy}>
          {busy ? 'Открываем…' : 'Получить бесплатный доступ'}
        </Button>
      </CardContent>
    </Card>
  );
};

export default TrialCard;
